import React, { useEffect, useState } from 'react';
import { Clock, Sparkles, ShoppingCart, X, Check, Gift, Tag, ArrowRight } from 'lucide-react';
function getEndTime(): number {
  const stored = localStorage.getItem('countdown_end');
  if (stored) {
    const end = parseInt(stored, 10);
    if (end > Date.now()) return end;
  }
  const end = Date.now() + 24 * 60 * 60 * 1000;
  localStorage.setItem('countdown_end', end.toString());
  return end;
}
export function CountdownBar() {
  const [endTime] = useState(getEndTime);
  const [timeLeft, setTimeLeft] = useState({
    h: 0,
    m: 0,
    s: 0
  });
  const [showModal, setShowModal] = useState(false);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    function update() {
      const diff = Math.max(0, endTime - Date.now());
      const h = Math.floor(diff / 3600000);
      const m = Math.floor(diff % 3600000 / 60000);
      const s = Math.floor(diff % 60000 / 1000);
      setTimeLeft({
        h,
        m,
        s
      });
    }
    update();
    const interval = setInterval(update, 1000);
    return () => clearInterval(interval);
  }, [endTime]);
  // Show bar only while the benefits section is in/near the viewport
  useEffect(() => {
    function checkVisibility() {
      const trigger = document.getElementById('order-bump-1');
      const section = document.getElementById('benefits-section');
      if (!trigger || !section) {
        setVisible(false);
        return;
      }
      const triggerRect = trigger.getBoundingClientRect();
      const sectionRect = section.getBoundingClientRect();
      // Show: trigger has entered viewport (scrolled into view)
      // Hide: entire benefits section has scrolled above viewport
      const triggerReached = triggerRect.top < window.innerHeight * 0.85;
      const sectionStillVisible = sectionRect.bottom > 0;
      setVisible(triggerReached && sectionStillVisible);
    }
    window.addEventListener('scroll', checkVisibility, {
      passive: true
    });
    checkVisibility();
    return () => window.removeEventListener('scroll', checkVisibility);
  }, []);
  const pad = (n: number) => n.toString().padStart(2, '0');
  const DISCOUNT_URL = 'https://pay.hotmart.com/Q104389187Y?off=h96re49q&checkoutMode=10&bid=1771440501662';
  const BASE_URL = 'https://pay.hotmart.com/Y104256235W?checkoutMode=10';
  return <>
      <div className={`fixed top-0 left-0 right-0 z-[60] bg-gradient-to-r from-red-600 via-red-500 to-orange-500 shadow-lg transition-transform duration-500 ${visible ? 'translate-y-0' : '-translate-y-full'}`} data-id="element-35">
        <div className="container mx-auto px-3 py-2 flex items-center justify-center gap-2 flex-wrap" data-id="element-36">
          <div className="flex items-center gap-1.5" data-id="element-37">
            <Sparkles className="w-4 h-4 text-yellow-300 animate-pulse" data-id="element-38" />
            <span className="text-white text-xs sm:text-sm font-bold uppercase tracking-wide" data-id="element-39">
              ⚡ Oferta especial solo por hoy
            </span>
          </div>

          <span className="text-white/70 text-xs hidden sm:inline" data-id="element-40">—</span>

          <span className="text-yellow-200 text-xs sm:text-sm font-semibold" data-id="element-41">
            El precio vuelve a $79.000 en:
          </span>

          <div className="flex items-center gap-1" data-id="element-42">
            <Clock className="w-3.5 h-3.5 text-yellow-300" data-id="element-43" />
            <div className="flex items-center gap-0.5" data-id="element-44">
              <span className="bg-white/20 text-white font-mono font-bold text-sm sm:text-base px-1.5 py-0.5 rounded" data-id="element-45">
                {pad(timeLeft.h)}
              </span>
              <span className="text-yellow-300 font-bold text-sm" data-id="element-46">:</span>
              <span className="bg-white/20 text-white font-mono font-bold text-sm sm:text-base px-1.5 py-0.5 rounded" data-id="element-47">
                {pad(timeLeft.m)}
              </span>
              <span className="text-yellow-300 font-bold text-sm" data-id="element-48">:</span>
              <span className="bg-white/20 text-white font-mono font-bold text-sm sm:text-base px-1.5 py-0.5 rounded" data-id="element-49">
                {pad(timeLeft.s)}
              </span>
            </div>
          </div>

          <button onClick={() => setShowModal(true)} className="relative flex items-center gap-1.5 bg-gradient-to-r from-green-400 to-green-500 text-white text-xs sm:text-sm font-bold px-3 py-1.5 rounded-lg ml-1 overflow-hidden animate-pulse hover:animate-none hover:from-green-500 hover:to-green-600 transition-colors duration-200" style={{
          boxShadow: '0 0 12px 3px rgba(74, 222, 128, 0.7)',
          animation: 'ctaPulse 1.5s ease-in-out infinite'
        }} data-id="element-50">
            {/* Shimmer sweep */}
            <span className="pointer-events-none absolute inset-0" style={{
            background: 'linear-gradient(105deg, transparent 40%, rgba(255,255,255,0.45) 50%, transparent 60%)',
            animation: 'shimmerSweep 2s linear infinite'
          }} data-id="element-51" />
            <ShoppingCart className="w-3.5 h-3.5 relative z-10" data-id="element-52" />
            <span className="relative z-10" data-id="element-53">OBTENER DESCUENTO</span>
            <style data-id="element-54">{`
              @keyframes ctaPulse {
                0%, 100% { box-shadow: 0 0 10px 2px rgba(74,222,128,0.6); transform: scale(1); }
                50% { box-shadow: 0 0 20px 6px rgba(74,222,128,0.9); transform: scale(1.05); }
              }
              @keyframes shimmerSweep {
                0% { transform: translateX(-100%); }
                100% { transform: translateX(200%); }
              }
            `}</style>
          </button>
        </div>
      </div>

      {/* Upsell Modal */}
      {showModal && <div className="fixed inset-0 z-[70] flex items-center justify-center p-4" onClick={e => {
      if (e.target === e.currentTarget) setShowModal(false);
    }} style={{
      backgroundColor: 'rgba(0,0,0,0.6)',
      backdropFilter: 'blur(4px)'
    }} data-id="element-55">
          <div className="bg-white rounded-2xl shadow-2xl max-w-lg w-full max-h-[90vh] overflow-y-auto relative" style={{
        animation: 'modalSlideIn 0.3s cubic-bezier(0.16, 1, 0.3, 1)'
      }} data-id="element-56">
            <style data-id="element-57">{`
              @keyframes modalSlideIn {
                from { opacity: 0; transform: scale(0.95) translateY(10px); }
                to { opacity: 1; transform: scale(1) translateY(0); }
              }
            `}</style>

            <button onClick={() => setShowModal(false)} className="absolute top-3 right-3 w-8 h-8 bg-gray-100 hover:bg-gray-200 rounded-full flex items-center justify-center transition-colors z-10" data-id="element-58">
              <X className="w-4 h-4 text-gray-600" data-id="element-59" />
            </button>

            {/* Header */}
            <div className="bg-gradient-to-r from-orange-500 via-red-500 to-orange-500 p-3 rounded-t-2xl text-center relative overflow-hidden" data-id="element-60">
              <div className="absolute top-0 left-0 w-24 h-24 bg-white/10 rounded-full blur-2xl -translate-x-1/2 -translate-y-1/2" data-id="element-61"></div>
              <div className="absolute bottom-0 right-0 w-20 h-20 bg-yellow-300/15 rounded-full blur-2xl translate-x-1/2 translate-y-1/2" data-id="element-62"></div>
              <div className="relative z-10" data-id="element-63">
                <div className="inline-flex items-center gap-1.5 bg-yellow-400 text-red-900 px-3 py-0.5 rounded-full text-[10px] font-bold uppercase tracking-wider mb-1.5" data-id="element-64">
                  <Sparkles className="w-3 h-3" data-id="element-65" />
                  ¡Espera! Oferta exclusiva
                </div>
                <h3 className="text-lg font-extrabold text-white leading-tight" data-id="element-66">
                  🔥 Llévate TODO con un{' '}
                  <span className="text-yellow-300 text-xl" data-id="element-67">
                    30% DE DESCUENTO
                  </span>
                </h3>
              </div>
            </div>

            {/* Content */}
            <div className="p-3" data-id="element-68">
              <p className="text-xs text-gray-600 text-center mb-2 leading-relaxed" data-id="element-69">
                Antes de irte solo con el e-book, mira lo que puedes llevarte{' '}
                <strong data-id="element-70">por mucho menos</strong>:
              </p>

              <div className="bg-gradient-to-br from-orange-50 to-yellow-50 p-3 rounded-xl border border-orange-200 mb-3" data-id="element-71">
                <div className="flex gap-3 items-start" data-id="element-72">
                  <img src="https://cdn.magicpatterns.com/uploads/1BbTjWu8cy6esJFPwLvaXu/ChatGPT_Image_10_feb_2026,_10_47_56_p.m..png" alt="Paquete completo con descuento" className="w-20 h-auto rounded-lg border border-orange-200 shadow-sm flex-shrink-0" data-id="element-73" />
                  <div className="w-full" data-id="element-74">
                    <p className="text-xs font-bold text-gray-800 mb-1.5 flex items-center gap-1" data-id="element-75">
                      <Gift className="w-3.5 h-3.5 text-orange-600" data-id="element-76" />
                      El paquete completo incluye:
                    </p>
                    <div className="space-y-1" data-id="element-77">
                      <div className="flex items-start gap-1.5" data-id="element-78">
                        <Check className="w-3.5 h-3.5 text-orange-600 flex-shrink-0 mt-0.5" strokeWidth={3} data-id="element-79" />
                        <span className="text-xs text-gray-700" data-id="element-80">
                          📖 <strong data-id="element-81">30 Recetas Naturales</strong> + 3 Regalos
                        </span>
                      </div>
                      <div className="flex items-start gap-1.5" data-id="element-82">
                        <Check className="w-3.5 h-3.5 text-teal-600 flex-shrink-0 mt-0.5" strokeWidth={3} data-id="element-83" />
                        <span className="text-xs text-gray-700" data-id="element-84">
                          🛒 <strong data-id="element-85">Compra bien</strong> — Ingredientes
                          económicos
                        </span>
                      </div>
                      <div className="flex items-start gap-1.5" data-id="element-86">
                        <Check className="w-3.5 h-3.5 text-amber-600 flex-shrink-0 mt-0.5" strokeWidth={3} data-id="element-87" />
                        <span className="text-xs text-gray-700" data-id="element-88">
                          🍳 <strong data-id="element-89">Cocina 1 vez por semana</strong> +
                          audioguía
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Price comparison */}
              <div className="bg-white border-2 border-green-200 rounded-xl p-3 mb-3 text-center" data-id="element-90">
                <div className="flex items-center justify-center gap-3 mb-1.5" data-id="element-91">
                  <div data-id="element-92">
                    <span className="text-xs text-gray-500 block" data-id="element-93">
                      Precio normal
                    </span>
                    <span className="text-base text-gray-400 line-through font-bold" data-id="element-94">
                      $55.999
                    </span>
                  </div>
                  <ArrowRight className="w-4 h-4 text-green-500" data-id="element-95" />
                  <div data-id="element-96">
                    <span className="text-xs text-green-600 font-bold block" data-id="element-97">
                      HOY con 30% OFF
                    </span>
                    <span className="text-xl text-green-600 font-extrabold" data-id="element-98">
                      $39.199
                    </span>
                  </div>
                </div>
                <div className="inline-flex items-center gap-1 bg-green-100 text-green-700 px-2.5 py-0.5 rounded-full text-xs font-bold" data-id="element-99">
                  <Tag className="w-3 h-3" data-id="element-100" />
                  Ahorras $16.800 COP
                </div>
              </div>

              {/* CTA Buttons */}
              <div className="space-y-2" data-id="element-101">
                <a href={DISCOUNT_URL} target="_blank" rel="noopener noreferrer" className="block w-full" data-id="element-102">
                  <button className="w-full bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white font-bold py-3 px-6 rounded-xl shadow-lg shadow-green-200 transition-all duration-200 flex flex-col items-center justify-center gap-0.5 text-center" data-id="element-103">
                    <span className="text-sm leading-tight flex items-center gap-2" data-id="element-104">
                      <Sparkles className="w-4 h-4 text-yellow-300" data-id="element-105" />
                      COMPRAR CON 30% DE DESCUENTO
                    </span>
                    <span className="text-xs opacity-90" data-id="element-106">
                      <span className="line-through opacity-70" data-id="element-107">$55.999</span> →{' '}
                      <strong data-id="element-108">$39.199 COP</strong>
                    </span>
                  </button>
                </a>
                <a href={BASE_URL} target="_blank" rel="noopener noreferrer" className="block w-full" data-id="element-109">
                  <button className="w-full bg-orange-500 hover:bg-orange-600 text-white font-bold py-2.5 px-6 rounded-xl border border-orange-600 transition-all duration-200 text-xs text-center uppercase tracking-wide" data-id="element-110">
                    NO GRACIAS, SOLO QUIERO EL E-BOOK — $19.999 COP
                  </button>
                </a>
              </div>

              <div className="mt-2 flex items-center justify-center gap-1.5 text-[10px] text-gray-400" data-id="element-111">
                <Sparkles className="w-3 h-3" data-id="element-112" />
                <span data-id="element-113">Garantía de 7 días • Pago seguro • Acceso inmediato</span>
              </div>
            </div>
          </div>
        </div>}
    </>;
}